import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lean-kpi',
  templateUrl: './lean-kpi.component.html',
  styleUrls: ['./lean-kpi.component.scss']
})

export class LeanKpiComponent implements OnInit {


  @Input() title          : string = "Kpi";
    
  _value : number;
  @Input() set value(val: number) {this._value = Math.round(val);}

  _value10 : number;
  @Input() set value10(val: number) {this._value10 = Math.round(val);}
  _value11 : number;
  @Input() set value11(val: number) {this._value11 = Math.round(val);}


  _value20 : number;
  @Input() set value20(val: number) {this._value20 = Math.round(val);}
  _value21 : number;
  @Input() set value21(val: number) {this._value21 = Math.round(val);}


  @Input() unit           : string = "";
  @Input() value1Label    : string;
  @Input() value2Label    : string;
 
  @Input() color          : string = "darkorange"
 

  constructor() {
  }


  ngOnInit() {

  }



}
